import { MenuItem, TextField } from '@mui/material'
import React, { ChangeEvent, useCallback, useMemo } from 'react'
import { formatTeamSelectLabel } from 'types'
import { useTeams } from '../../hooks/useTeams'

export function TimelineTeamControlSelect({
  onAfterChangeTeam,
}: {
  onAfterChangeTeam?: () => void
}) {
  const { teamsData, onChangeTeam, activeTeamId } = useTeams()

  const teamsOptions = useMemo(() => {
    return teamsData.map((team) => ({
      label: formatTeamSelectLabel(team),
      value: team.id,
    }))
  }, [teamsData])

  const handleChangeTeam = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value ? parseInt(event.target.value, 10) : null
      onChangeTeam(value)
      onAfterChangeTeam?.()
    },
    [onAfterChangeTeam, onChangeTeam],
  )

  return (
    <TextField
      label="Select Team"
      select
      size="small"
      onChange={handleChangeTeam}
      value={activeTeamId || ''}
      sx={{ flexGrow: 1 }}
    >
      {teamsOptions.map((option) => (
        <MenuItem key={String(option.value)} value={String(option.value)}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  )
}
